import { LOGIN_SUCCESS } from "../constants/MyM";

const initialState = {
  isSuperAdmin: parseInt(localStorage.getItem("is_super_admin") || "0"),
};

export default function userAuthReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      const isSuperAdmin = parseInt(action.payload?.result?.[0]?.is_super_admin ?? 0);
      return { ...state, isSuperAdmin };
    }
    default:
      return state;
  }
}
